// extracted by mini-css-extract-plugin
export var post = "time-module--post--b4f81";
export var read = "time-module--read--9aabc";